import { ButtonWrapper } from "./styled"

const Button = ({ isNa = false, className, children, ...props }) => {
    return (
        <ButtonWrapper disabled={isNa} style={isNa ? { cursor: "not-allowed" } : { cursor: "pointer" }} className={`clickable px-20 py-5 ${className}`} {...props} >{children}</ButtonWrapper>
    )
}

export default Button